export const ModalNames = {
  bookToTaxDifferenceDeleteModal: 'bookToTaxDifferenceDeleteModal',
};

export const allCountries = {
  countryCode: 'ALL',
  countryDescription: 'ALL COUNTRIES',
};

export const CTT_REGEXP = /[A-Z]{2}-[A-Z0-9]{3}/;

export const GROUPED_COLUMN_MIN_WIDTH = 160;

export const CTT_COLUMN_DEFAULT_WIDTH = 40;
